const callDetails = {
  'callDetails.empty':
    'Aqui você pode consultar os detalhes de qualquer atendimento do histórico.',
  'callDetails.events.empty':
    'Nenhum evento foi registrado durante esse atendimento.',
};

export default callDetails;
